export default "__VITE_ASSET__6Vp$0vMe__"